import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL;

const SlaCollectionService = {
    smartcapture: async () => axios.get(`${API_URL}/sla_collection_point/smartcapture/getAllToSelect`).then(({data}) => data.map(d => ({value: d.id, label: d.text}))).catch((err) => { throw err })
};

export default SlaCollectionService;